import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

/**
 * Deep-link wrapper: `/radar/opp_abc` redirige a `/radar/mapa?opp=opp_abc`.
 * Ahí el mapa abre el panel lateral y hace flyTo al aviso.
 * Mantiene URLs viejas compartidas funcionando sin salir de la pantalla del mapa.
 */
export default function RadarFichaDeepLink() {
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (id) navigate(`/radar?opp=${id}`, { replace: true });
  }, [id, navigate]);
  return null;
}
